import React from 'react';
import CustomImage from '../../../components/custom-image';

const Healthcare = () => {
  return (
    <div className="accordion-body">
      <div className="sd-content">
          <div className="left">
            <div className="blue-box">
              <p className="feature-title"><strong>Key Features</strong></p>
              <div className="sd-column">
                <div className="left">
                  <p className="feature-subtitle">More than</p>
                  <p className="bold-text blue-text">35</p>
                  <p className="feature-benifit">initiatives across our Group companies</p>
                </div>
                <div className="right">
                  <p className="feature-subtitle">Nearly</p>
                  <p className="bold-text blue-text">1.9 million</p>
                  <p className="feature-benifit">people beneﬁt from these programs</p>
                </div>
              </div>
              
            </div>
            <div className="bottom-content">
              <p><strong>Types of Interventions</strong></p>
              <p>
              Support to Primary Health Centres; HIV/AIDS awareness programmes; Health camps; Mobile Health Vans; Specialist doctor support; Nutrition
              programmes; Vedanta-run hospitals; Health awareness drives
              </p>
            </div>
          </div>
          <div className="right">
            <div className="img-wrapper">
              <CustomImage className="custom-image" imageName="healthcare.jpg" alt="Health care" maxWidth="768" />
            </div>
          </div>
      </div>
    </div>
  );
};

export default Healthcare;
